import { render, staticRenderFns } from "./SwitchInternational.vue?vue&type=template&id=8eabfcac&scoped=true&"
import script from "./SwitchInternational.vue?vue&type=script&lang=js&"
export * from "./SwitchInternational.vue?vue&type=script&lang=js&"
import style0 from "./SwitchInternational.vue?vue&type=style&index=0&id=8eabfcac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eabfcac",
  null
  
)

export default component.exports